import withPaytoAgreementProcessing from 'features/to/HOCs/payment/withPaytoAgreementProcessing';
import withWatchPaytoGuidelineOptional from 'features/to/HOCs/payment/withWatchPaytoGuidelineOptional';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import Popup from './popup';

const AuthorisePaytoAccountPopup = withPaytoAgreementProcessing(
  withWatchPaytoGuidelineOptional(Popup)
);

const AuthorisePaytoAccountModal = ({
  isShow,
  action,
  actionClose,
  modalOptions,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <AuthorisePaytoAccountPopup
      isOpen={isShow}
      buttonLabel1={t('')}
      onClose={handleOnClose}
      buttonLabel2={t('')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1202}
      zIndexModal={1202}
      modalOptions={modalOptions}
      isShowIframeModal
    />
  );
};

export default AuthorisePaytoAccountModal;
